import React, { useState, useEffect } from 'react';
import { Modal, FormGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'react-multi-select-component';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../Components/Utility/Loader/Loader';
import { addUser, updateUsersDetails } from '../store/User.action';
import { editSupplierUser, addSupplierUser } from '../../Supplier/store/Supplier.action';
import { CloseIcon } from '../../../bombiix-icon';

function AddEditUsersModel({ toggle, onSave, onOpen, title, id, itemList }) {
  const { t } = useTranslation('common');
  const UsersReducers = useSelector((reducerstate) => reducerstate);
  const {
    Users,
    UserDetails: { userInfo, isSupplierLoggedIn },
  } = UsersReducers;
  const { userGroupsCardList } = Users;
  const [showLoader, setShowLoader] = useState(false);
  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    titles: '',
  });
  const [errors, setErrors] = useState({});
  const { firstName, lastName, email, titles } = state;
  const dispatch = useDispatch();
  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const fieldValidation = () => {
    const obj = {};
    let count = 0;
    for (const key in state) {
      if (!state[key]) {
        obj[key] = true;
      } else {
        count += 1;
        obj[key] = false;
      }
    }
    // Email format validation using a more efficient regex
    if (state.email) {
      // Split validation into parts to avoid catastrophic backtracking
      const [localPart, domain] = state.email.split('@');
      const domainParts = domain?.split('.');

      // Validate local part (before @) and domain parts
      const isValid =
        localPart?.length > 0 &&
        domainParts?.length >= 2 &&
        domainParts.every((part) => part.length > 0) &&
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(localPart) &&
        /^[a-zA-Z0-9.-]+$/.test(domain);

      if (!isValid) {
        obj.email = 'invalid';
      }
    }
    // All fields filled and email valid
    if (count === 4 && obj.email !== 'invalid') {
      setErrors({});
      return true;
    }
    setErrors(obj);
    return false;
  };
  const onSubmitMethod = async (e) => {
    e.preventDefault();
    if (fieldValidation()) {
      setShowLoader(true);
      const formData = {
        email,
        firstName,
        lastName,
        title: titles,
        group: selectedUsers,
      };
      if (id) {
        formData.userId = id;
        if (isSupplierLoggedIn) {
          formData.supplierId = userInfo.userId;
          await dispatch(editSupplierUser(formData, id, t));
        } else {
          await dispatch(updateUsersDetails(formData, t));
        }
        toggle();
        onSave?.();
      } else {
        if (isSupplierLoggedIn) {
          formData.supplierId = userInfo.userId;
          await dispatch(addSupplierUser(formData, t));
        } else {
          await dispatch(addUser(formData, t));
        }
        toggle();
        onSave?.();
      }
      setShowLoader(false);
    }
  };
  useEffect(() => {
    const list = [...userGroupsCardList];
    setUsersList(list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGroupsCardList]);

  useEffect(() => {
    if (id) {
      const dataIndex = forDataIndex();
      const value = itemList[dataIndex];
      console.log(value);
      if (value) {
        setState((prev) => ({
          ...prev,
          firstName: value?.firstName,
          lastName: value?.lastName,
          titles: value?.title,
          email: value?.email,
        }));

        addUsersToGroup(value?.groups?.map((val) => val._id));
      }
    }
  }, [id, itemList]);

  const addUsersToGroup = (selected) => {
    setSelectedUsers(selected);
  };

  const forDataIndex = () => {
    return itemList?.length ? itemList.findIndex((item) => item?._id === id) : 0;
  };
  const onChangeVal = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <Modal show={onOpen} size="md" backdrop="static" aria-labelledby="contained-modal-title-vcenter" className="custom-modal modal-small" onHide={toggle}>
      <form>
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
            <CloseIcon size={28} onClick={toggle} className="cursor-pointer" />
          </div>
        </Modal.Header>
        <Modal.Body>
          {showLoader ? (
            <Loader />
          ) : (
            <>
              <FormGroup>
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    name="firstName"
                    placeholder={t('USER_GROUP_LIBRARY.ENTER_FIRST_NAME')}
                    value={firstName}
                    onChange={onChangeVal}
                    className="form-control"
                  />
                  <label className="asterisk-req">
                    {t('USER_GROUP_LIBRARY.FIRST_NAME')}
                    <span>*</span>
                  </label>
                </div>
                {errors?.firstName && <small className="error-message">{t('USER_GROUP_LIBRARY.VALIDATION_ERROR.FIRST_NAME_IS_REQUIRED')}</small>}
              </FormGroup>
              <FormGroup>
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    name="lastName"
                    placeholder={t('USER_GROUP_LIBRARY.ENTER_LAST_NAME')}
                    value={lastName}
                    onChange={onChangeVal}
                    className="form-control"
                  />
                  <label className="asterisk-req">
                    {t('USER_GROUP_LIBRARY.LAST_NAME')}
                    <span>*</span>
                  </label>
                </div>
                {errors?.lastName && <small className="error-message">{t('USER_GROUP_LIBRARY.VALIDATION_ERROR.LAST_NAME_IS_REQUIRED')}</small>}
              </FormGroup>

              <FormGroup>
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    name="titles"
                    placeholder={t('USER_GROUP_LIBRARY.ENTER_JOB_TITLE')}
                    value={titles}
                    onChange={onChangeVal}
                    className="form-control"
                  />
                  <label className="asterisk-req">
                    {t('USER_GROUP_LIBRARY.JOB_TITLE')}
                    <span>*</span>
                  </label>
                </div>
                {errors?.titles && <small className="error-message">{t('USER_GROUP_LIBRARY.VALIDATION_ERROR.JOB_TITLE_IS_REQUIRED')}</small>}
              </FormGroup>

              <FormGroup>
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    name="email"
                    placeholder={t('USER_GROUP_LIBRARY.ENTER_EMAIL')}
                    disabled={!!id}
                    value={email}
                    onChange={onChangeVal}
                    className="form-control"
                  />
                  <label className="asterisk-req">
                    {t('USER_GROUP_LIBRARY.EMAIL')}
                    <span>*</span>
                  </label>
                </div>
                {errors?.email === true && <small className="error-message">{t('USER_GROUP_LIBRARY.VALIDATION_ERROR.EMAIL_IS_REQUIRED')}</small>}
                {errors?.email === 'invalid' && (
                  <small className="error-message">{t('USER_GROUP_LIBRARY.VALIDATION_ERROR.EMAIL_IS_INVALID') || 'Email is invalid'}</small>
                )}
              </FormGroup>
              {!isSupplierLoggedIn && (
                <FormGroup>
                  <label className="select-label asterisk-req">{t('USER_GROUP_LIBRARY.USERS')}</label>
                  <MultiSelect
                    name="users"
                    options={usersList.map((e) => {
                      e.label = `${e.name}`;
                      e.value = e?._id;

                      return e;
                    })}
                    className="custom-multiselect"
                    value={usersList.filter((element) => {
                      return selectedUsers?.includes(element?._id);
                    })}
                    onChange={(selected) => addUsersToGroup(selected.map((val) => val._id))}
                    labelledBy={t('USER_GROUP_LIBRARY.SELECT_USERS')}
                  />
                </FormGroup>
              )}
              <div className="modal-buttons mt-4 d-flex justify-content-between">
                <button onClick={toggle} className="btn btn-default">
                  {t('COMMON_LABEL.CANCEL')}
                </button>

                <button onClick={(e) => onSubmitMethod(e)} className="btn btn-default">
                  {id ? t('COMMON_LABEL.UPDATE') : t('COMMON_LABEL.ADD')}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </form>
    </Modal>
  );
}

export default AddEditUsersModel;
